<template>
        <div class="text-center overflow-auto" v-if="_props.selected_user!=null" >
            
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->       
            <div class="col-md-8 fixed-top m-auto" v-if="mailSent!=null">
                <b-alert
                    :show="alert.dismissCountDown"
                    dismissible :variant="mailSent? 'success' : 'danger'"
                    @dismissed="[alert.dismissCountDown=0, mailSent=null]"
                    @dismiss-count-down="countDownChanged">
                    <div class="text-center m-auto pl-4" :class="mailSent? 'text-dark':'text-danger'"> <br>
                    <span  v-if="mailSent"  >  
                      <span class="lead">Nous avons envoyé le mail de l'invitation à  :<br> {{_props.selected_user.email}} </span> 
                        <br> <hr>
                        <span >Si l'utilisateur ne reçoit pas un mail de notre part, cela signifie que son adresse mail est invalide.
                            <br> Dans ce cas, veuillez utiliser une adresse mail valide.</span>
                    </span>
                      <span v-else class="lead">Nous ne pouvons pas trouver un utilisateur avec cette adresse e-mail : <br> {{_props.selected_user.email}} </span>
                    <br><hr>
                    <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                    </div>
                </b-alert>
            </div>

<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *  -->  
       <h4> Vous avez attribué ces rôles à <b> {{fullname}} </b> : </h4>
        <b-list-group >
            <b-list-group-item  v-for="struct in _props.selected_user.structures" v-bind:key="struct.pivot.id" class="p-0 border-0 bg-transparent">
                <span v-if="struct.id==$store.getters.structure_id">
                    <span v-if='struct.pivot.role_id==1'> <h5>Responsable</h5></span>
                    <span v-else-if='struct.pivot.role_id==3' >
                        <h5>   Adhérent(e) 
                        <span v-if='struct.pivot.code==null'> - </span>
                        <span v-else> ( {{struct.pivot.code}} ) </span>
                        </h5>
                    </span>
                </span>
            </b-list-group-item>
        </b-list-group>

 <div class="overflow-auto mt-5" style="height : 290px ;">     
        <div class="">
            <h5>Voulez-vous annuler l'ajout de cet utilisateur à votre structure ?</h5>
            <div class="mt-3" >
                    <button class="btn btn-default mr-3"  @click="Close" :disabled="isBusy">Non</button>
                    <b-button variant="primary" disabled v-if="isBusy">
                        <b-spinner small v-if="isBusy"></b-spinner>
                        Oui...
                    </b-button>
                    <b-button v-else @click="AnnulerRole()" class="btn btn-primary"> Oui </b-button>
                </div>
        </div>
<hr class="w-75 mt-4 mb-5">
        <div class="">
            <h5>Voulez-vous renvoyer le mail de l'invitation à <b>{{fullname}} </b> <br> à l'adresse mail suivante : {{_props.selected_user.email}} ?</h5>
            <div class="mt-3" >
                    <button class="btn btn-default mr-3"  @click="Close" :disabled="isBusy">Non</button>
                    <b-button variant="primary" disabled v-if="isBusy">
                        <b-spinner small v-if="isBusy"></b-spinner>
                        Oui...
                    </b-button>
                    <b-button v-else @click="RenvoyerInvitation()" class="btn btn-primary"> Oui </b-button>
                </div>
        </div>
</div>          
    </div>
</template>
<script>
    import api from "../../config/_api";

export default {
    name :"AnnulerRole",
    data (){
        return {
                error : false,
                errormsg : "",
                isBusy : false ,
                mailSent : null,
                alert : {
                    dismissSecs: 10,
                    dismissCountDown: 0,
            },
        }
    },
    props :{
        selected_user: {
            type: Object,
            required: false
        }, 
        structure_id : null,
        action : ""
    },
    computed : {
        fullname(){
            return this.selected_user.title+" "+this.selected_user.firstname+" "+this.selected_user.lastname ; 
        }
    },
    methods : {
        Close(){
            this.$emit('close');
        },
        user_has_roles(){
            
                var user_has_role=[];
                for (var struct of this.selected_user.structures){
                    if(struct.id==this.structure_id)
                    {
                        user_has_role.push(
                                {   
                                    id : struct.pivot.id, 
                                    role : struct.pivot.role_id,
                                    status : struct.pivot.status,
                                }
                            );
                    }
                }
                return user_has_role;
                
        },

        AnnulerRole(){
                let data = {
                    action : 'Annuler',
                    user_id:this.selected_user.id,
                    user_email : this.selected_user.email,
                    structure_id: this.structure_id,
                    user_has_roles : this.user_has_roles(),
                }
                this.isBusy=true;
                this.axios({url: api.url + 'Role/Annuler/',data:data,method: 'POST' })
                .then(result => {
                    this.error=false;
                    this.isBusy=false;
                    this.$emit('AnnulerRole');
                }, error => {
                    this.error=true;
                    this.errormsg=error;
                    this.isBusy=false;
                    this.$emit('close');
                });
            },
            RenvoyerInvitation(){
                var data = {
                            action : 'RenvoyerInvitation',
                            user_id:this.selected_user.id,
                            user_email : this.selected_user.email,
                            structure_id: this.structure_id,
                            user_has_roles : this.user_has_roles(),
                    };
                    
                this.axios({url: api.url + 'Role/invitation/renvoyer', data: data, method: 'POST' })
                .then(result => {
                    this.mailSent=true;
                }, error => {
                    this.mailSent=false;
                });
                this.showAlert();

            },
            
            countDownChanged(dismissCountDown) {
                this.alert.dismissCountDown = dismissCountDown;
            },
            showAlert() {
                this.alert.dismissCountDown = this.alert.dismissSecs;
            },
    }

}

</script>